import "./i18n";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Note: vite-react-ssg wraps the tree with HelmetProvider itself (and passes
// a context object it later reads via extractHelmet). Adding our own
// HelmetProvider here would shadow that context, so PageSEO's <Helmet> calls
// would not reach the SSG renderer. Don't add one back.

const queryClient = new QueryClient();

interface AppProps {
  children: React.ReactNode;
}

const App = ({ children }: AppProps) => (
  <ErrorBoundary>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          {children}
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

export default App;
